import { Icon } from '@iconify/react';
import { useState } from 'react';

const JobFilters = ({ filters, onFilterChange, onReset }) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const filterSections = [
    {
      id: 'locations',
      title: 'Lokasi',
      icon: 'mdi:map-marker',
      options: [
        { value: 'Jakarta', label: 'Jakarta', count: 86 },
        { value: 'Surabaya', label: 'Surabaya', count: 42 },
        { value: 'Bandung', label: 'Bandung', count: 31 },
        { value: 'Yogyakarta', label: 'Yogyakarta', count: 18 },
        { value: 'Remote', label: 'Remote', count: 54 },
      ],
    },
    {
      id: 'types',
      title: 'Tipe Pekerjaan',
      icon: 'mdi:briefcase-outline',
      options: [
        { value: 'Full-time', label: 'Full-time', count: 112 },
        { value: 'Part-time', label: 'Part-time', count: 28 },
        { value: 'Contract', label: 'Contract', count: 35 },
        { value: 'Internship', label: 'Internship', count: 22 },
      ],
    },
    {
      id: 'experiences',
      title: 'Pengalaman',
      icon: 'mdi:chart-line',
      options: [
        { value: 'Entry Level', label: 'Entry Level (0-1 thn)' },
        { value: 'Junior', label: 'Junior (1-3 thn)' },
        { value: 'Mid', label: 'Mid (3-5 thn)' },
        { value: 'Senior', label: 'Senior (5+ thn)' },
      ],
    },
    {
      id: 'salaries',
      title: 'Range Gaji',
      icon: 'mdi:cash',
      options: [
        { value: '<5jt', label: '< Rp 5 Juta' },
        { value: '5-10jt', label: 'Rp 5 - 10 Juta' },
        { value: '10-20jt', label: 'Rp 10 - 20 Juta' },
        { value: '>20jt', label: '> Rp 20 Juta' },
      ],
    },
  ];

  const getActiveFilterCount = () => {
    let count = 0;
    Object.values(filters).forEach((arr) => {
      count += arr.length;
    });
    return count;
  };

  const activeCount = getActiveFilterCount();

  return (
    <>
      {/* Mobile Filter Toggle */}
      <div className="lg:hidden mb-4">
        <button
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          className="w-full flex items-center justify-between bg-white rounded-xl border border-gray-200 px-4 py-3 text-sm font-medium text-gray-700 hover:border-zentra-300 transition-colors"
        >
          <span className="flex items-center gap-2">
            <Icon icon="mdi:filter-variant" className="text-lg" />
            Filter Lowongan
            {activeCount > 0 && (
              <span className="bg-zentra-600 text-white text-xs rounded-full px-2 py-0.5">
                {activeCount}
              </span>
            )}
          </span>
          <Icon
            icon={isMobileOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'}
            className="text-lg"
          />
        </button>
      </div>

      {/* Filter Panel */}
      <div
        className={`
          lg:col-span-1 order-2 lg:order-1
          ${isMobileOpen ? 'block' : 'hidden lg:block'}
        `}
      >
        <div className="bg-white rounded-2xl border border-gray-100 p-5 sticky top-20">
          {/* Header */}
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-sm font-semibold text-gray-900 flex items-center gap-2">
              <Icon icon="mdi:filter-variant" className="text-zentra-500" />
              Filter
              {activeCount > 0 && (
                <span className="bg-zentra-100 text-zentra-600 text-xs font-medium px-2 py-0.5 rounded-full">
                  {activeCount}
                </span>
              )}
            </h3>
            <button
              className="text-xs text-zentra-600 hover:text-zentra-700 font-medium transition-colors flex items-center gap-1"
              onClick={onReset}
            >
              <Icon icon="mdi:refresh" className="text-sm" />
              Reset Semua
            </button>
          </div>

          {/* Filter Sections */}
          <div className="space-y-6">
            {filterSections.map((section) => (
              <div
                key={section.id}
                className={`filter-section ${
                  section.id !== 'salaries' ? 'pb-5 border-b border-gray-100' : ''
                }`}
              >
                <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3 flex items-center gap-2">
                  <Icon icon={section.icon} className="text-sm" />
                  {section.title}
                </h4>
                <div className="space-y-2">
                  {section.options.map((option) => {
                    const isChecked = filters[section.id]?.includes(option.value) || false;
                    return (
                      <label
                        key={option.value}
                        className="flex items-center gap-2 cursor-pointer group hover:bg-zentra-50 rounded-lg px-2 py-1.5 transition-colors"
                      >
                        <input
                          type="checkbox"
                          className="w-4 h-4 rounded border-gray-300 text-zentra-600 focus:ring-zentra-500 focus:ring-offset-0 transition-colors cursor-pointer"
                          checked={isChecked}
                          onChange={() => onFilterChange(section.id, option.value)}
                        />
                        <span
                          className={`text-sm transition-colors ${
                            isChecked ? 'text-zentra-600 font-medium' : 'text-gray-600'
                          }`}
                        >
                          {option.label}
                        </span>
                        {option.count !== undefined && (
                          <span className="text-xs text-gray-400 ml-auto">
                            {option.count}
                          </span>
                        )}
                      </label>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          {/* Active Filters Summary */}
          {activeCount > 0 && (
            <div className="mt-5 pt-4 border-t border-gray-100">
              <div className="flex flex-wrap gap-2">
                {Object.entries(filters).map(([key, values]) =>
                  values.map((value) => {
                    // Find label for the value
                    const section = filterSections.find((s) => s.id === key);
                    const option = section?.options.find((o) => o.value === value);
                    return (
                      <span
                        key={`${key}-${value}`}
                        className="inline-flex items-center gap-1 bg-zentra-50 text-zentra-600 text-xs font-medium px-2.5 py-1 rounded-full"
                      >
                        {option?.label || value}
                        <button
                          onClick={() => onFilterChange(key, value)}
                          className="hover:text-zentra-800 transition-colors"
                        >
                          <Icon icon="mdi:close" className="text-sm" />
                        </button>
                      </span>
                    );
                  })
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default JobFilters;
